import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import pt from 'vuetify/es5/locale/pt'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      variations: true,
      customProperties: true
    },
    themes: {
      light: {
        primary: colors.red,
        secondary: '#424242',
        accent: colors.red.accent2,
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        erudioRedText: '#F44336',
        navBtnText: '#A64BAA',
        beyondTitle: '#401580',
        beyondText: '#363636',
        beyondGreen: '#49d880'
      },
      dark: {
        primary: colors.red,
        secondary: '#424242',
        accent: colors.red.accent2,
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        erudioRedText: '#F44336',
        navBtnText: '#A64BAA',
        beyondTitle: '#401580',
        beyondText: '#363636',
        beyondGreen: '#49d880'
      }
    }
  },
  lang: {
    locales: { pt },
    current: 'pt'
  }
})
